import { Location } from '@app/shared/routes';

const BaleaLocation = new Location({ path: '/balea' });

export { BaleaLocation };
